export const languages = {
    en: 'English',
    pt: 'Português'
};
